import querystring from 'querystring';
import api from '../api';

class DataServiceCategory {
  addAcademyIa(data) {
    return api.post('academyia', data);
  }

  getAcademyIa(params) {
    const url = 'academyia?' + querystring.stringify(params);
    return api.get(url);
  }

  getAcademyIaById(id) {
    return api.get(`academyia/${id}`);
  }

  updateAcademyIa(id, data) {
    return api.put(`academyia/${id}`, data);
  }
}

export default new DataServiceCategory();
